"use strict";

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var ReactDOMComet = require("react-dom");

var flushControlled = ReactDOMComet.unstable_flushControlled;
module.exports = flushControlled;


//////////////////
// WEBPACK FOOTER
// ./~/draft-js/lib/DraftEditorFlushControlled.js
// module id = 1195
// module chunks = 0